export var cookies = {
    "JSESSIONID": true,
    "HBD-SCN": true, // Session-Cookie
    "HBD-SSO": true, // SingleSignOn
    "HBD-COOKIE-SETTINGS": true, // Cookie-Settings
    "HBD-SP": true, // SP-Session-Cookie
    "GTM": true, // Google Tag Manager incl. Google Analytics
    "HOTJAR": true,
    "RECAPTCHA": true,
    "ADSENSE": true,
    "YEXT": true // YEXT-Pixel
};